import React, { useState, useEffect } from "react";
import axios from "axios";
import { Button } from "../../components/ui/button";
import { toast } from "react-toastify";

const ImportarEquipos = () => {
  const [clientes, setClientes] = useState([]);
  const [cliente, setCliente] = useState("");
  const [file, setFile] = useState(null);
  const [ultimoJob, setUltimoJob] = useState(null);
  const [loadingClientes, setLoadingClientes] = useState(true);
  const [loadingImport, setLoadingImport] = useState(false);
  const [loadingJobs, setLoadingJobs] = useState(false);

  const token = localStorage.getItem("token");
  const API_URL = process.env.REACT_APP_API_URL;

  const cargarUltimoJob = async () => {
    setLoadingJobs(true);
    try {
      const res = await axios.get(`${API_URL}/utils/import-jobs?limit=1`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setUltimoJob(res.data?.[0] || null);
    } catch (error) {
      toast.error("No se pudo cargar el historial de importaciones");
    } finally {
      setLoadingJobs(false);
    }
  };

  useEffect(() => {
    const fetchClientes = async () => {
      try {
        const res = await axios.get(`${API_URL}/clientes`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setClientes(res.data);
      } catch (error) {
        toast.error("Error al cargar lista de clientes");
      } finally {
        setLoadingClientes(false);
      }
    };

    fetchClientes();
    cargarUltimoJob();
    // eslint-disable-next-line
  }, []);

  const handleUpload = async () => {
    if (!cliente) return toast.warning("Seleccione un cliente");
    if (!file) return toast.warning("Seleccione un archivo Excel");

    setLoadingImport(true);

    const formData = new FormData();
    formData.append("file", file);
    formData.append("clienteId", cliente);

    try {
      const res = await axios.post(`${API_URL}/utils/import-excel`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      toast.success(
        res.data?.message ||
          "Archivo recibido. Se procesará en segundo plano y te notificaremos por push.",
      );
      setFile(null);
      await cargarUltimoJob();
    } catch (error) {
      toast.error(error.response?.data?.message || "Error al importar equipos");
    } finally {
      setLoadingImport(false);
    }
  };

  return (
    <div className="space-y-4 p-4 bg-white rounded shadow">
      <h2 className="text-lg font-semibold">📦 Importar Equipos desde Excel</h2>

      {loadingClientes ? (
        <p className="text-gray-500">Cargando clientes...</p>
      ) : clientes.length > 0 ? (
        <select
          className="border rounded-lg w-full px-3 py-2 mb-3"
          value={cliente}
          onChange={(e) => setCliente(e.target.value)}
        >
          <option value="">Seleccione cliente</option>
          {clientes.map((c) => (
            <option key={c._id} value={c._id}>
              {c.name}
            </option>
          ))}
        </select>
      ) : (
        <p className="text-red-500">⚠️ No hay clientes registrados</p>
      )}

      <input
        type="file"
        accept=".xlsx,.xls"
        onChange={(e) => setFile(e.target.files[0])}
        className="border rounded-lg w-full px-3 py-2 mt-1"
      />

      <div className="flex gap-3">
        <Button
          onClick={handleUpload}
          disabled={loadingImport}
          className={`text-white ${
            loadingImport
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-blue-600 hover:bg-blue-700"
          }`}
        >
          {loadingImport ? "Encolando importación..." : "Importar equipos"}
        </Button>

        <a
          href="/Formato_Importacion_Equipos.xlsx"
          download
          className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded flex items-center justify-center"
        >
          Descargar formato
        </a>

        <Button
          onClick={cargarUltimoJob}
          disabled={loadingJobs}
          className="bg-slate-600 hover:bg-slate-700 text-white"
        >
          {loadingJobs ? "Actualizando..." : "Ver último resultado"}
        </Button>
      </div>

      {ultimoJob && (
        <div className="mt-4 border p-3 rounded bg-gray-50 space-y-2">
          <h4 className="font-semibold">📊 Última importación</h4>
          <p>
            Estado: <b>{ultimoJob.estado}</b>
          </p>
          <p>Total filas: {ultimoJob.resumen?.totalFilas || 0}</p>
          <p>✅ Creados: {ultimoJob.resumen?.creados || 0}</p>
          <p>⚠️ Duplicados: {ultimoJob.resumen?.duplicados || 0}</p>
          <p>❌ Errores: {ultimoJob.resumen?.errores || 0}</p>

          {ultimoJob.error && (
            <p className="text-red-600">Error general: {ultimoJob.error}</p>
          )}

          {Array.isArray(ultimoJob.detalles) &&
            ultimoJob.detalles.length > 0 && (
              <div className="overflow-auto border rounded bg-white max-h-64">
                <table className="w-full text-sm">
                  <thead className="bg-gray-100">
                    <tr>
                      <th className="text-left px-2 py-1">Fila</th>
                      <th className="text-left px-2 py-1">Resultado</th>
                      <th className="text-left px-2 py-1">
                        Corrección sugerida
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {ultimoJob.detalles.map((detalle, index) => (
                      <tr key={`${detalle.fila}-${index}`} className="border-t">
                        <td className="px-2 py-1">{detalle.fila}</td>
                        <td className="px-2 py-1">{detalle.status}</td>
                        <td className="px-2 py-1">
                          {detalle.correccion || "—"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
        </div>
      )}
    </div>
  );
};

export default ImportarEquipos;
